import { render, staticRenderFns } from "./WorkspaceProjects.vue?vue&type=template&id=bb6ed5da&scoped=true&"
import script from "./WorkspaceProjects.vue?vue&type=script&lang=js&"
export * from "./WorkspaceProjects.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceProjects.vue?vue&type=style&index=0&id=bb6ed5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6ed5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb6ed5da')) {
      api.createRecord('bb6ed5da', component.options)
    } else {
      api.reload('bb6ed5da', component.options)
    }
    module.hot.accept("./WorkspaceProjects.vue?vue&type=template&id=bb6ed5da&scoped=true&", function () {
      api.rerender('bb6ed5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceProjects.vue"
export default component.exports